import React from 'react'
import { massCheck, copyAttempt } from '../timesheetUtils';

const TimesheetsTab = ({teachers, timesheets, schoolList, schoolTab, currentMonth, currentYear, month, year, setOpenTimesheet, setListOfTeachersTimesheetsForThisMonth}) => {

    const openUpATimesheet = (teacherId) => {
        let arrayOfTeachersTimesheets = []
        timesheets.forEach((sheet) => teacherId === sheet.teacherId && (arrayOfTeachersTimesheets.push(sheet), setOpenTimesheet(sheet)))
        setListOfTeachersTimesheetsForThisMonth(arrayOfTeachersTimesheets)
    }

    const checkIfTheyTurnedInTimesheet = (teacherId) => {
        let foundTimesheet = timesheets.find((sheet) => sheet.teacherId === teacherId)
        return foundTimesheet ? foundTimesheet.status.charAt(0).toUpperCase() + foundTimesheet.status.slice(1) : 'Missing'
    }

    const checkIfTheyTurnedInMultipleTimesheets = (teacherId) => {
        let listOfTimesheetsObject = {approved: 0, submitted: 0}
        timesheets.forEach((sheet) => {
            if(sheet.teacherId === teacherId) {
                sheet.status === 'Approved' ? listOfTimesheetsObject = {approved: ++listOfTimesheetsObject.approved, submitted: ++listOfTimesheetsObject.submitted} : listOfTimesheetsObject.submitted = ++listOfTimesheetsObject.submitted   
            }
        })
        return listOfTimesheetsObject
    }

    const ifTheyHaveTurnedInTheirTimesheetCalculatePay = (teacherId) => {
        let foundSheets = []
        timesheets.forEach((sheet) => sheet.teacherId === teacherId && foundSheets.push(sheet))
        return foundSheets.length > 0 ? calculateEstimatedPay(foundSheets) : '-' 
    }

    const calculateEstimatedPay = (arrayOfSheets) => {
        let total = 0
        let minutesTaught = 0
        let allExtras = 0
        for(let i = 0; i < arrayOfSheets.length; i++) {
            let theTimesheet = arrayOfSheets[i]
            for(let i = 0; i < theTimesheet.families.length; i++) {
                let fam = theTimesheet.families[i]
                for(let i = 0; i < fam.lessons.length; i++) {
                    minutesTaught = Number(minutesTaught) + Number(fam.lessons[i].lessonLength)
                }
                for(let i = 0; i < fam.cancellations.length; i++) {
                    if(fam.cancellations[i].cancellor === 'student less than 24hrs') {
                        minutesTaught = Number(minutesTaught) + Number(fam.cancellations[i].lessonLength)
                    }
                }
                for(let i = 0; i < fam.extras.length; i++) {
                    allExtras = Number(allExtras) + Number(fam.extras[i].amount)
                }
            }
        }
        return `$${((minutesTaught/60) * Number(arrayOfSheets[0].teacherRate)) + allExtras}`
    }

    return(
        <div>
        {schoolList.map((school) => (
            <div className="whole-timesheet-wrapper" key={school}>
            {school === schoolTab &&
            <div key={school}>
                <div className="timesheet-school-name__title">
                    <div className="student-db-btn-wrapper on-timesheet-wrapper">
                        <div className="add-email-btn on-timesheet" onClick={() => copyAttempt()}>Copy Emails</div>
                    </div>
                </div>
                <table className="student-table">
                    <thead>
                        <tr>
                            <th><input onClick={(e) => massCheck(e.target.checked)} type="checkbox" style={{border: '1px solid black'}} /></th>
                            <th>Status</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Students</th>
                            <th>Amount Due</th>
                        </tr>
                    </thead>
                    {currentMonth === month && currentYear === year ? 
                    <tbody>
                        {/* ---------------------------------CURRENT TIMESHEET LIST ------------------------------------------*/}
                        {teachers.map(teacher => (
                            teacher.School === school &&
                            <tr style={teacher.newStudentList.length === 0 && checkIfTheyTurnedInTimesheet(teacher.TeacherID) === 'Missing' ? {opacity: '0.4'} : {opacity: 1}} key={teacher.TeacherID} className="each-row">
                                <td><input className={"student-checkbox"} style={{border: '1px solid black'}} type="checkbox" value={teacher.Email}/></td>
                                {checkIfTheyTurnedInTimesheet(teacher.TeacherID) === 'Missing' && <td onClick={() => openUpATimesheet(teacher.TeacherID)}  style={checkIfTheyTurnedInTimesheet(teacher.TeacherID) === 'Missing' && teacher.newStudentList.length > 0 ? {color: '#7e1111', backgroundColor: '#f5b3b3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'} : {color: 'black'}}>{checkIfTheyTurnedInTimesheet(teacher.TeacherID)}</td>}
                                {checkIfTheyTurnedInTimesheet(teacher.TeacherID) === 'Submitted' && <td onClick={() => openUpATimesheet(teacher.TeacherID)}  style={{color: '#7e5611', backgroundColor: '#f5ddb3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'}}>{checkIfTheyTurnedInTimesheet(teacher.TeacherID)}</td>}
                                {checkIfTheyTurnedInTimesheet(teacher.TeacherID) === 'Approved' &&<td onClick={() => openUpATimesheet(teacher.TeacherID)}  style={{color: '#117e18', backgroundColor: '#bcf5b3', fontWeight: 900, padding: '2px', borderRadius: '3px', fontSize: '12px', width: '100px', display: 'inline-block', margin: '8px auto', textAlign: 'center'}}>{checkIfTheyTurnedInTimesheet(teacher.TeacherID)}</td>}
                                <td onClick={() => openUpATimesheet(teacher.TeacherID)} >{teacher.Name} {checkIfTheyTurnedInMultipleTimesheets(teacher.TeacherID).submitted > 1 ? <div className='multiple-timesheets-warning' style={checkIfTheyTurnedInMultipleTimesheets(teacher.TeacherID).approved === checkIfTheyTurnedInMultipleTimesheets(teacher.TeacherID).submitted ? {color: 'green', border: '1px solid green'} : {color: 'orange', border: '1px solid orange'}}>{checkIfTheyTurnedInMultipleTimesheets(teacher.TeacherID).approved}/{checkIfTheyTurnedInMultipleTimesheets(teacher.TeacherID).submitted} timesheets</div> : null}</td>
                                <td onClick={() => openUpATimesheet(teacher.TeacherID)} >{teacher.Email}</td>
                                <td onClick={() => openUpATimesheet(teacher.TeacherID)} >{teacher.newStudentList.length}</td>
                                <td onClick={() => openUpATimesheet(teacher.TeacherID)} >{ifTheyHaveTurnedInTheirTimesheetCalculatePay(teacher.TeacherID)} {checkIfTheyTurnedInMultipleTimesheets(teacher.TeacherID).submitted > 1 && <div className='multiple-timesheet-total'>Total</div>} </td>
                            </tr>
                        ))}
                    </tbody>
                    :
                    // --------------------------------------------OUT OF DATE TIMESHEET LIST???------------------------------------------------
                    <tbody>
                        {timesheets.map(timesheet => (
                            timesheet.school === school &&
                            <tr key={timesheet.timesheetId} className="each-row">
                                <td><input className={"student-checkbox"} style={{border: '1px solid black'}} type="checkbox" value={timesheet.email}/></td>
                                <td onClick={() => openUpATimesheet(timesheet.teacherId)} >{timesheet.teacherName}</td>
                                <td onClick={() => openUpATimesheet(timesheet.teacherId)} >{timesheet.email}</td>
                                <td onClick={() => openUpATimesheet(timesheet.teacherId)} >-</td>
                                {timesheet.status === 'Submitted' && <td onClick={() => openUpATimesheet(timesheet.teacherId)}  style={{color: 'black'}}>{timesheet.status}</td>}
                                {timesheet.status === 'Approved' &&<td onClick={() => openUpATimesheet(timesheet.teacherId)}  style={{color: 'green'}}>{timesheet.status}</td>}
                                <td onClick={() => openUpATimesheet(timesheet.teacherId)} >{ifTheyHaveTurnedInTheirTimesheetCalculatePay(timesheet.teacherId)}</td>
                            </tr>
                        ))}
                    </tbody>
                    }
                </table>
            </div>
            }
        </div>
        ))}
    </div>  
    )
}
export default TimesheetsTab;